import { FormConfig } from '@shared/interfaces/form-configs/form-config';
import { CreateMeteringPointCommand, MeteringPointType } from '@app/api/dmc';
import {
  meteringPointTypeVEProductionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-veproduction.form-config';
import {
  meteringPointTypeAnalysisFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-analysis.form-config';
import {
  meteringPointTypeSurplusProductionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-surplusproduction.form-config';
import {
  meteringPointTypeNetProductionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-netproduction.form-config';
import {
  meteringPointTypeSupplyToGridFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-supplytogrid.form-config';
import {
  meteringPointTypeConsumptionFromGridFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-consumption-from-grid.form-config';
import {
  meteringPointTypeWholesaleServicesFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-wholesaleservices.form-config';
import {
  meteringPointTypeOwnProductionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-ownproduction.form-config';
import {
  meteringPointTypeNetFromGridFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-net-from-grid.form-config';
import {
  meteringPointTypeNetToGridFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-net-to-grid.form-config';
import {
  meteringPointTypeTotalConsumptionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-totalconsumption.form-config';
import {
  meteringPointTypeGridLossCorrectionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-grid-loss-correction.form-config';
import {
  meteringPointTypeElectricalHeatingFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-electricalheating.form-config';
import {
  meteringPointTypeNettoConsumptionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-nettoconsumption.form-config';
import {
  meteringPointTypeOtherConsumptionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-other-consumption.form-config';
import {
  meteringPointTypeOtherProductionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-other-production.form-config';
import {
  meteringPointTypeConsumptionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-consumption.form-config';
import {
  meteringpointtypeProductionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-production.form-config';
import {
  meteringpointtypeExchangeFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-exchange.form-config';
import {
  meteringPointTypeEffectPaymentFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-effect-payment.form-config';
import {
  meteringPointTypeExchangeReactiveEnergyFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-exchange-reactive-energy.form-config';
import {
  meteringPointTypeInternalUseFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-internal-use.form-config';
import {
  meteringPointTypeCollectiveNetProductionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-collective-net-production.form-config';
import {
  meteringPointTypeCollectiveNetConsumptionFormConfig
} from '@views/meteringpoint/configs/meteringpointtype-collective-net-consumption.form-config';

export const meteringPointTypeConfig: Partial<Record<MeteringPointType, FormConfig<CreateMeteringPointCommand>>> = {
  [MeteringPointType.VEProduction]: meteringPointTypeVEProductionFormConfig,
  [MeteringPointType.Analysis]: meteringPointTypeAnalysisFormConfig,
  [MeteringPointType.SurplusProductionGroup]: meteringPointTypeSurplusProductionFormConfig,
  [MeteringPointType.NetProduction]: meteringPointTypeNetProductionFormConfig,
  [MeteringPointType.SupplyToGrid]: meteringPointTypeSupplyToGridFormConfig,
  [MeteringPointType.ConsumptionFromGrid]: meteringPointTypeConsumptionFromGridFormConfig,
  [MeteringPointType.WholesaleServices]: meteringPointTypeWholesaleServicesFormConfig,
  [MeteringPointType.OwnProduction]: meteringPointTypeOwnProductionFormConfig,
  [MeteringPointType.NetFromGrid]: meteringPointTypeNetFromGridFormConfig,
  [MeteringPointType.NetToGrid]: meteringPointTypeNetToGridFormConfig,
  [MeteringPointType.TotalConsumption]: meteringPointTypeTotalConsumptionFormConfig,
  [MeteringPointType.GridLossCorrection]: meteringPointTypeGridLossCorrectionFormConfig,
  [MeteringPointType.ElectricalHeating]: meteringPointTypeElectricalHeatingFormConfig,
  [MeteringPointType.NettoConsumption]: meteringPointTypeNettoConsumptionFormConfig,
  [MeteringPointType.OtherConsumption]: meteringPointTypeOtherConsumptionFormConfig,
  [MeteringPointType.OtherProduction]: meteringPointTypeOtherProductionFormConfig,
  [MeteringPointType.EffectPayment]: meteringPointTypeEffectPaymentFormConfig,
  [MeteringPointType.ExchangeReactiveEnergy]: meteringPointTypeExchangeReactiveEnergyFormConfig,
  [MeteringPointType.InternalUse]: meteringPointTypeInternalUseFormConfig,
  [MeteringPointType.Consumption]: meteringPointTypeConsumptionFormConfig,
  [MeteringPointType.Production]: meteringpointtypeProductionFormConfig,
  [MeteringPointType.Exchange]: meteringpointtypeExchangeFormConfig,
  [MeteringPointType.CollectiveNetProduction]: meteringPointTypeCollectiveNetProductionFormConfig,
  [MeteringPointType.CollectiveNetConsumption]: meteringPointTypeCollectiveNetConsumptionFormConfig,
}
